<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    
    <div class="title">行李回国订单详情</div>
      <div class="weui-msg__text-area">
          <h2 class="weui-msg__title">订单号：{{orderDetail.order_id}}</h2>
          <h2 class="weui-msg__title">{{order_status}}</h2>
          <div class="notice-yellow" v-show="orderDetail.pay_status==0">请在{{orderDetail.expiration_time| moment("HH点mm分")}}前完成支付，否则订单将失效</div>

          <h2 class="weui-msg__title"  v-if="orderDetail.pay_status==2">待支付金额：<span class="color-orange">{{orderDetail.payment_amount | numeral('$0,0.00')}}</span></h2>
      </div>
      
      <div class="weui-cells__title" v-if="isWorkDone && tracking_array">快递单号</div>
      <div class="weui-cells" v-if="isWorkDone && tracking_array">
        <a class="weui-cell" href="javascript:;" v-for="(item, index) in tracking_array" >
            <div class="weui-cell__bd">
                <p v-if="tracking_array.length>1">快递单号{{index+1}}</p>
                <p v-else>快递单号</p>
            </div>
            <div class="weui-cell__ft">{{item}}</div>
        </a>
      </div>

      <div class="weui-panel weui-panel_access" v-if="orderDetail.pay_status==1||orderDetail.pay_status==2||orderDetail.pay_status==3||orderDetail.pay_status==4">
          <div class="weui-panel__bd">
              <div class="weui-media-box weui-media-box_text">
                  <h4 class="weui-media-box__title">请上传中国收件人身份证照片</h4>
                  <p class="weui-media-box__desc">个人物品类进出境快件报关时，都需要根据中国海关要求提交收件人身份证影印件及海关需要的其它单证。</p>
              </div>
          </div>
          <template v-for="(item, index) in orderDetail.details.home_address">
            <label class="weui-cell weui-check__label " v-if="orderDetail.details.idCard_pics.length>2*index">
                <div class="weui-cell__bd">
                    <p class="text-center color-wechat"> <span class="icon-check-circle "></span> 已完成上传 </p>
                </div>
            </label>
            <label class="weui-cell weui-check__label car" v-else>
                <div class="weui-cell__bd">
                    <p class="park-assist" @click="uploadSFZ()"> <span class="icon-upload parking-icon"></span> 点击上传 {{item.home_name}} 身份证 </p>
                </div>
            </label>
          </template>
      </div>
      <div class="weui-cells__title" v-if="orderDetail.pay_status==2||orderDetail.pay_status==3||orderDetail.pay_status==4">费用详情</div>

      <div class="weui-cells" v-if="orderDetail.pay_status==3||orderDetail.pay_status==4">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>总费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.order_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>定金</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.deposit_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>服务尾款</p>
            </div>
            <div class="weui-cell__ft">{{(orderDetail.order_amount - orderDetail.deposit_amount) | numeral('$0,0.00')}}</div>
        </a>
      </div>

      <div class="weui-cells" v-if="orderDetail.pay_status==2">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>总费用</p>
            </div>
            <div class="weui-cell__ft">{{Number(orderDetail.payment_amount) + Number(orderDetail.deposit_amount) | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>已付定金</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.deposit_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>需支付费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.payment_amount | numeral('$0,0.00')}}</div>
        </a>
      </div>

      <div class="weui-cells" v-if="orderDetail.pay_status==2||orderDetail.pay_status==3||orderDetail.pay_status==4">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.labor_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>快递费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.parcel_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>垃圾处理费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.rubbish_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>楼梯费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.stairs_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>出车回程费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.return_trip_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>高速费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.etoll_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.gst_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>其他费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>优惠减免</p>
            </div>
            <div class="weui-cell__ft">-{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
        </a>
      </div>

      <div class="weui-cells__title" v-if="orderDetail.pay_status==0||orderDetail.pay_status==1">预计价格（仅作参考，以实际服务为准）</div>
      <div class="weui-cells" v-if="orderDetail.pay_status==0">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.labor_hour_cost">每小时{{pricing.labor_hour_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>楼梯费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.stairs_cost">{{pricing.stairs_cost | numeral('$0,0.00')}} </span>
              <span v-if="pricing.stairs_cost==0">无</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>出车回程费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.return_trip_cost">{{pricing.return_trip_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>


        <label class="weui-cell weui-check__label car">
           
            <div class="weui-cell__bd">
                <router-link :to="vehicle_id"><p class="park-assist"> <span class="icon-info parking-icon"></span> 点击查看收费标准 </p></router-link>
            </div>
        </label>
      </div>
      <div class="weui-cells" v-if="orderDetail.pay_status==1 && !isPriceOut && !isWorkDone">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft" v-if="pricing.labor_hour_cost">每小时{{pricing.labor_hour_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>楼梯费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.stairs_cost">{{pricing.stairs_cost | numeral('$0,0.00')}} </span>
              <span v-if="pricing.stairs_cost==0">无</span>
            </div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>出车回程费</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="pricing.return_trip_cost">{{pricing.return_trip_cost | numeral('$0,0.00')}}</span>
            </div>
        </a>

        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <router-link :to="vehicle_id"><p class="park-assist"> <span class="icon-info parking-icon"></span> 点击查看收费标准 </p></router-link>
            </div>
        </label>
      </div>

      <div class="weui-cells" v-if="orderDetail.pay_status==1 && isPriceOut && !isWorkDone">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.labor_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>楼梯费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.stairs_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>出车回程费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.return_trip_cost | numeral('$0,0.00')}}</div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <router-link :to="vehicle_id"><p class="park-assist"> <span class="icon-info parking-icon"></span> 点击查看收费标准 </p></router-link>
            </div>
        </label>
      </div>

      <div class="weui-cells" v-if="orderDetail.pay_status==1 && isWorkDone">
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>基础服务费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.labor_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>快递费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.parcel_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>垃圾处理费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.rubbish_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>楼梯费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.stairs_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>出车回程费</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.return_trip_cost | numeral('$0,0.00')}}</div>
        </a>

        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>高速费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.etoll_cost | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>GST费用</p>
            </div>
            <div class="weui-cell__ft">总费用10%</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>其他费用</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.other_amount | numeral('$0,0.00')}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>优惠减免</p>
            </div>
            <div class="weui-cell__ft">-{{orderDetail.offers_amount | numeral('$0,0.00')}}</div>
        </a>

      </div>


      <div class="weui-cells__title">服务详情</div>

      <div class="weui-cells">

        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.service_date| moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>
        <a class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>取行李地址</p>
            </div>
            <div class="weui-cell__ft">{{orderDetail.details.out_address.out_street}}, {{orderDetail.details.out_address.out_suburb}}, {{orderDetail.details.out_address.out_state}}, {{orderDetail.details.out_address.out_postcode}}<br>{{orderDetail.details.attribute.out_floor}} {{orderDetail.details.attribute.out_parking}}</div>
        </a>
        <a  v-for="(item, index) in orderDetail.details.home_address" class="weui-cell" href="javascript:;" >
            <div class="weui-cell__bd">
                <p>中国地址 {{index>0 ? index+1 : ''}}</p>
            </div>
            <div class="weui-cell__ft">{{item.home_name}}, {{item.home_phone}}<br> {{item.home_address}}</div>
        </a>


        <a class="weui-cell" href="javascript:;" v-show="order.data.agency">
            <div class="weui-cell__bd">
                <p>Coupon Code 优惠码</p>
            </div>
            <div class="weui-cell__ft">{{order.data.agency}}</div>
        </a>
      </div>

      
      <div class="btn-box" v-if="orderDetail.pay_status==1||orderDetail.pay_status==3||orderDetail.pay_status==4||orderDetail.pay_status==5">
        <div class="btn active" @click="goback()">返回</div>
      </div>
      
      <div v-if="orderDetail.pay_status==0||orderDetail.pay_status==2">
        <br>
      </div>

      <div class="btn-box-fix" v-if="orderDetail.pay_status==0||orderDetail.pay_status==2">
        <div class="btn-container">
          <div class="btn active" @click="checkSubmit()">立即支付</div>
        </div>
      </div>

      <transition name="fade">
          <div id="loadingToast" v-show="isSendingPricing">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取报价</p>
              </div>
          </div>
      </transition>

      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在获取订单</p>
              </div>
          </div>
      </transition>

      <div class="js_dialog" v-show="isLeaving">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">尚未完成支付</strong></div>
              <div class="weui-dialog__bd">确定要离开订单详情页吗？离开后需要登录账号才可以完成支付</div>
              <div class="weui-dialog__ft">
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="goto('/login')">离开</a>
                  <div  class="weui-dialog__btn weui-dialog__btn_daojia" @click="checkSubmit()">立即支付</div>
              </div>
          </div>
      </div>


    </div>


</template>

<script>
import qs from 'qs'

export default {
  name: 'order-detail',
  data () {
    return {
      isSending:false,
      isSendingPricing:false,
      isLeaving:false,
      pricing:{},
      orderDetail: {
          type_id: "",
          order_number: "",
          member_id: "",
          member_name: "",
          member_phone: "",
          member_mail: "",
          service_date:"",
          service_time: "",
          deposit_amount: "",
          offers_amount:"",
          payment_amount: "",
          order_amount: "",
          order_status: "",
          pay_status: "",
          prepaid_time:"",
          pay_time: "",
          type_name: "",
          details: {
              vehicle_type:"",
              move_scale:"",
              plate_number: "",
              estimated_time: "",
              in_address: {
                  move_in_name: "",
                  move_in_phone: "",
                  move_in_state: "",
                  move_in_suburb: "",
                  move_in_street: "",
                  move_in_postcode: ""
              },
              out_address: {
                  move_out_name: "",
                  move_out_phone: "",
                  move_out_state: "",
                  move_out_suburb: "",
                  move_out_street: "",
                  move_out_postcode: ""
              },
              home_address: {
                  home_name: "",
                  home_phone: "",
                  home_address: "",
              },
              pathway_address: [
                  {
                      name: "",
                      phone: "",
                      state: "",
                      suburb: "",
                      street: "",
                      postcode: "",
                      sort: ""
                  },
                  {
                      name: "",
                      phone: "",
                      state: "",
                      suburb: "",
                      street: "",
                      postcode: "",
                      sort: ""
                  }
              ],
              labor_cost: "",
              return_trip_cost: "",
              stairs_cost: "",
              weight_cost: "",
              etoll_cost: "",
              km: "",
              service_start_time: "",
              service_end_time: "",
              service_pause_time: null,
              service_pause_second:"",
              attribute: {
                  move_in_floor: "",
                  move_in_parking: "",
                  move_out_floor: "",
                  move_out_parking: "",
                  move_other_valuables: "",
                  move_valuables: {
                  }
              }
          }
      },
      order:{
        data:{
        }
      }
    }
  },
  methods: {
    getData(){
      if(this.isSending){
        return false;
      }
      else{
        let dataObject={};
        let that = this;
        this.isSending = true;
        dataObject.order_number = this.$route.query.id;
        dataObject.token = localStorage.token;

        this.axios.post(this.apiURL()+'/Order/orderInfo', qs.stringify(dataObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.orderDetail = response.data.data;
            if(that.orderDetail.pay_status==0||that.orderDetail.pay_status==1){
              that.getPricing();
            }
          }
          else{
            if(!that.checkLogin()){
              that.$router.push('/login');
            }
            alert("订单获取失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
            console.log(error)
            alert("订单获取失败，请检查网络并重新尝试")
            that.isSending=false;
        });
      }
    },
    getInvoice(){
      if(this.orderDetail.invoices_url){
          window.open(this.orderDetail.invoices_url,'_blank');
      }
      else{
        this.$router.push(this.invoiceURL);
      }
    },
    getPricing(){
      if(this.isSendingPricing){
        return false;
      }
      else{
        this.isSendingPricing = true;
        let that = this;

        //做对象的副本出来
        let orderObject = this.orderDetail.cost_data;
        this.axios.post(this.apiURL()+'/Cost/getCost', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.pricing = response.data.data;
            that.isSendingPricing=false;
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSendingPricing=false;
          }
        })
        .catch(function (error) {
          alert("获取报价失败，请检查网络并尝试刷新页面")
          that.isSendingPricing=false;
          console.log(error);
        });
      }
    },
    checkSubmit(){
      if(this.orderDetail.pay_status==0){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&status=0&amount='+this.depositAmount());
      }
      if(this.orderDetail.pay_status==2){
        this.$router.push('/order-prepay?id='+this.$route.query.id+'&status=2&amount='+this.orderDetail.payment_amount);
      }
    },
    goback(){
      if(this.orderDetail.pay_status==0&&!localStorage.token){
        this.isLeaving = true;
      }
      else{
        this.$router.push('/order');
      }
    },
    uploadSFZ(){
      window.location.href = '/idupload/?token='+localStorage.token+"&order="+this.$route.query.id;
    },
  },
  components: {
  },
  computed: {
    tracking_array: function (){
      if(this.orderDetail.details.tracking_no){
        return this.orderDetail.details.tracking_no.split(" ");
      }
      else{
        return "";
      }
    },
    orderIDFromURL: function (){
      let theString = this.$route.query.id;
      if(theString.includes("?")){
        return theString.substring(0, theString.indexOf('?'));
      }
      else{
        return theString;
      }
    },
    pricingURL: function (){
      let theString = this.$route.query.id;
      return '/move/order-detail/price?id=' + theString;
    },
    invoiceURL: function (){
      let theString = this.$route.query.id;
      return '/move/order-detail/invoice?id=' + theString;
    },
    vehicle_id : function () {
      return "/baggage-price";
    },
    //isPriceOut变量，在客服填写完预计时间和预计工人数后就会出现
    isPriceOut: function (){
      let theNum = Number(this.orderDetail.details.labor_cost);
      if(theNum>0){
        return true;
      }
      else{
        return false;
      }
    },
    //isPriceOut变量，在客服填写完预计时间和预计工人数后就会出现
    isWorkDone: function (){
      let workEnd = this.orderDetail.details.service_end_time;
      if(workEnd.length>1){
        return true;
      }
      else{
        return false;
      }
    },
    order_status: function () {
      let result = '';
      switch (this.orderDetail.pay_status) {
        case "0":
          result = '订单已确认，待支付定金 $'+ this.depositAmount()
          break;
        case "1":
          if(this.orderDetail.details.service_end_time.length>1){
            result = '服务结束，正在确认收费细节'
          }
          else{
            result = '已付定金，等待服务'
          }
          break;
        case "2":
          result = '服务完毕，待支付全款'
          break;
        case "3":
          result = '已付款，等待确认到账'
          break;
        case "4":
          result = '已付款完毕，感谢使用我们的服务'
          break;
        case "5":
          result = '已退款'
          break;
        default:
          console.log("订单状态异常");
      }
      return result;
    },

    move_valuables: function () {
      if(Object.keys(this.orderDetail.details.attribute.move_valuables).length){
        let result = '';
        let concatResult = '';
        let allValuables = Object.keys(this.orderDetail.details.attribute.move_valuables);
        concatResult = allValuables.join(", ");

        if(typeof this.order.data.move_other_valuables != "undefined"){
          concatResult = concatResult+this.order.data.move_other_valuables;
        }
        return concatResult;
      }
      else{
        return "无";
      }
    },
    service_period: function () {
      let result = '';
      switch (this.orderDetail.details.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("service_period conv error");
      }
      return result;
    },
  },
  created: function () {
    this.getData();

  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ {
  .weui-cell__ft{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width:70%;
    font-size:0.9em;
  }

  .weui-msg__title{
    font-size:1.1em;
    margin-bottom:0;
  }

  .park-assist{
      text-align:center;
      color:#fe9567;
  }

  .prepay-img{
    width:100%;
  }
} 

</style>



// WEBPACK FOOTER //
// src/pages/baggage/order-detail.vue